import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp } from "../lib/redux";

const useAgencyAccountLinkingEnabled = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  return Boolean(agencyID);
};

export default useAgencyAccountLinkingEnabled;
